import React, { RefObject, VoidFunctionComponent, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { BasketButton } from '@/components/responsive/product/basketBlock/basketButton/BasketButton';
import { useScrollPosition, useWindowSize } from '@/customHooks/hooks';
import { RootState } from '@/models/appState/RootState';
import { addToCartAction } from "@/redux/reducers/responsive/cart/cartActions";
import { BREAKPOINT_DESKTOP, DEFAULT_QUANTITY, LAYER_TYPE, MAX_QUANTITY } from '@/utils/constants';

const getOptions = (min: number, max: number): number[] => {
  const options: number[] = [];
  for (let i: number = min; i <= max; i++) {
    options.push(i);
  }
  return options;
};

const shouldPositionBeFixed = (
  windowSize: { width: number, height: number },
  scrollPosition: number,
  basketBlockRef: RefObject<HTMLDivElement>,
  isQuantityHidden?: boolean,
): boolean => {
  if (windowSize.width >= BREAKPOINT_DESKTOP || isQuantityHidden) {
    return false;
  }
  return (
    scrollPosition - windowSize.height >
    (basketBlockRef?.current?.getBoundingClientRect().top || 0)
  );
};

interface Props {
  basketBlockYPosition?: number;
  setBasketBlockYPosition?: (basketBlockYPosition: number) => void;
  isQuantityHidden?: boolean;
  isBasketButtonEnable?: boolean;
  handleOpenLayer: (layerType: string, selectedProductId?: string) => void;
  productId: string;
  offerId?: number;
  sellerName?: string;
  trackingData?: {};
  isSelectedWarranty?: boolean;
  warrantyCode?: string;
  isSealableInStore?: boolean;
}

interface T2SParams {
  pID: string;
  iID: string;
}

declare const _t2sparams: T2SParams;
declare const T2S: { reco: () => void };


const BasketBlock: VoidFunctionComponent<Props> = ({
  basketBlockYPosition,
  setBasketBlockYPosition,
  isQuantityHidden = false,
  isBasketButtonEnable = true,
  handleOpenLayer,
  productId,
  offerId,
  sellerName,
  trackingData,
  isSelectedWarranty = false,
  warrantyCode,
  isSealableInStore
}) => {
  const dispatch = useDispatch();
  const [isPositionFixed, setIsPositionFixed] = useState(false);
  const basketBlockRef: RefObject<HTMLDivElement> = useRef(null);
  const shopId: string = useSelector((state: RootState) => state.header.shopId || state.header.shop?.shopInfos?.id);

  const scrollPosition = useScrollPosition();
  const windowSize = useWindowSize();
  const optionNumbers = getOptions(DEFAULT_QUANTITY, MAX_QUANTITY);

  const handleScrollResize = () => {
    const yPosition =
        (basketBlockRef?.current?.getBoundingClientRect().top || 0) + scrollPosition;
    if (yPosition !== basketBlockYPosition) {
      setBasketBlockYPosition?.(yPosition);
    }
    if (windowSize.width >= BREAKPOINT_DESKTOP) {
      setIsPositionFixed(false);
    }
  }

  useEffect(() => {
    handleScrollResize();
  }, [windowSize]);
  useEffect(() => {
    handleScrollResize();
    setIsPositionFixed(
      shouldPositionBeFixed(
        windowSize,
        scrollPosition,
        basketBlockRef,
        isQuantityHidden
      )
    );
  }, [scrollPosition]);

  const addToCartHandler = (quantity: number) => {
    try {
      _t2sparams.pID = "4001";
      _t2sparams.iID = "1583";
      T2S.reco();
    } catch (e) {
      console.log("l'appel à T2S a échoué ", e);
    }

    if (isPositionFixed) {
      trackingData = {
        ...trackingData,
        eventLabel: "CTA Sticky"
      };
    }
    if(isBasketButtonEnable) {
      // If product saleability = yes.
      dispatch(addToCartAction({
        productId,
        quantity,
        offerId,
        sellerName,
        callback: () => handleOpenLayer(LAYER_TYPE.BASKET),
        trackingData,
        warrantyCode: isSelectedWarranty ? warrantyCode : undefined,
      }));
    } else {
      // If product saleability = canBe.
      handleOpenLayer(!!shopId ? LAYER_TYPE.STOCK_LOCATOR : LAYER_TYPE.ATTACHEMENT, productId);
    }
  }

  return (
    <div ref={basketBlockRef} className='basket-container'>
      <BasketButton
        isPositionFixed={isPositionFixed}
        isQuantityHidden={isQuantityHidden}
        optionNumbers={optionNumbers}
        handleClick={addToCartHandler}
        sellerName={sellerName}
        isBasketButtonEnable={isBasketButtonEnable}
        isSealableInStore={isSealableInStore}
      />
    </div>
  );
}
export default BasketBlock;
